import React from 'react';

import OtpInput from 'react-otp-input';
import { makeStyles } from 'tss-react/mui';

import { OTP_LENGTH } from 'global-services/constants/OhsConstants';

const useStyles = makeStyles()({
  container: {
    'input:not(:first-of-type):not(:last-child)': {
      borderRightWidth: '1px',
      borderLeftWidth: '1px',
    },
    'input:first-of-type': {
      borderRightWidth: '1px',
    },
    'input:last-child': {
      borderLeftWidth: '1px',
    },
  },
  input: {
    height: '64px',
    width: '48px!important',
    borderStyle: 'solid',
    borderColor: '#CECECE',
    borderWidth: '2px',
    fontSize: '20px',
    fontWeight: '500',
    borderRadius: '6px!important',
  },
  focus: {
    border: 'transparent',
    outline: '2px solid #3874CB',
    zIndex: 1,
    outlineOffset: '-2px',
  },
});

interface Props {
  value: string;
  setValue: (value: string) => void;
  shouldAutoFocus?: boolean;
  length: number;
  disabled?: boolean;
}

function OhsOTPInput(props: Props) {
  const firstInputRef = React.useRef<HTMLInputElement>(null);
  const { classes } = useStyles();

  const focusFirstInput = () => {
    if (firstInputRef.current) {
      firstInputRef.current.focus();
    }
  };

  React.useEffect(() => {
    if (props.value.length === 0) focusFirstInput();
  }, [props.value]);

  const handleChange = (otp: string) => {
    props.setValue(otp);
    if (otp.length === 1) focusFirstInput();
  };

  return (
    <OtpInput
      value={props.value}
      onChange={handleChange}
      numInputs={props.length}
      containerStyle={classes.container}
      inputStyle={classes.input}
      shouldAutoFocus={props.shouldAutoFocus}
      renderSeparator={<span> &nbsp;&nbsp; </span>}
      renderInput={(inputProps, index) => {
        const otpInputProps = {
          ...inputProps,
          ...(index === 0 && { ref: firstInputRef }),
        };
        return <input disabled={props.value.length === OTP_LENGTH} {...otpInputProps} />;
      }}
    />
  );
}

OhsOTPInput.defaultProps = {
  shouldAutoFocus: false,
  disabled: false,
};
export default OhsOTPInput;
